import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

export class ProgramDetails extends Component {
    makeArray = (v) => {

        // separate each row of user input by "enter" key pressed
        let txtArray = v.split('\n');
        return txtArray.filter(txt => txt !== "");
    }

    render() {
        let program = this.props.program;

        // program's description / summary
        let description;
        if (program.longDescription === "") {
            description = program.caption;
        } else {
            description = program.longDescription;
        }

        let trainingAreas;

        // if organization has entered any information about training areas of the program
        if (program.trainingAreas.length <= 0 | program.trainingAreas === "") {
            trainingAreas = <p>There is no available information.</p>
        } else if (Array.isArray(program.trainingAreas)) {
            trainingAreas = program.trainingAreas.map((item, index) => {
                return <li key={index}>{item}</li>; // give bullet point to each row of content
            })
        } else {
            trainingAreas = this.makeArray(program.trainingAreas).map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        }

        let forWhom;
        // if organization has entered any information about target audience of the program
        if (program.audience.length <= 0 | program.audience === "") {
            forWhom = <p>There is no available information.</p>
        } else if (Array.isArray(program.audience)) {
            forWhom = program.audience.map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        } else {
            forWhom = this.makeArray(program.audience).map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        }

        let clientRatio;
        // if organization has entered any information about client ratio of the program
        if (program.clientRatio.length <= 0 | program.clientRatio === "") {
            clientRatio = <p>There is no available information.</p>
        } else if (Array.isArray(program.clientRatio)) {
            clientRatio = program.clientRatio.map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        } else {
            clientRatio = this.makeArray(program.clientRatio).map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        }

        let operatingHours;
        // if organization has entered any information about operating hours of the program
        if (program.operatingHours.length <= 0 | program.operatingHours === "") {
            operatingHours = <p>There is no available information.</p>
        } else if (Array.isArray(program.operatingHours)) {
            operatingHours = program.operatingHours.map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        } else {
            operatingHours = this.makeArray(program.operatingHours).map((item, index) => {
                return <li key={index}>{item}</li>;
            })
        }

        let contacts = program.contact;
        let contactPeople;
        // if organization has entered any information about contact information of the program
        if (contacts.length <= 0 | contacts === "" | contacts === undefined) {
            contactPeople = <p>There is no available information.</p>
        } else {
            let contactsKey = Object.keys(contacts);
            contactPeople = contactsKey.map((item, index) => {
                let contact = contacts[item][0].map((item, index) => {
                    return <li key={index}>{item}</li>;
                });
                return <div key={index}><h3 className="title-bd">{item}</h3><ul className="body-lt">{contact}</ul></div>
            })
        }

        return (
            <Container fluid>
                <Row>
                    <Col sm="12" lg="7" className="p-5">
                        <h2 className="title-bd">Description</h2>
                        <p className="body-lt">{description}</p>
                        <h3 className="title-bd">Training Areas</h3>
                        <ul className="body-lt">
                            {trainingAreas}
                        </ul>
                        <h3 className="title-bd">For Whom</h3>
                        <ul className="body-lt">
                            {forWhom}
                        </ul>
                        <h3 className="title-bd">Client Ratio</h3>
                        <ul className="body-lt">
                            {clientRatio}
                        </ul>
                    </Col>
                    <Col sm="12" lg="5" className="p-5">
                        <h2 className="title-bd">Operating Hours</h2>
                        <ul className="body-lt">
                            {operatingHours}
                        </ul>
                        <h2 className="title-bd">Contact Information</h2>
                        {contactPeople}
                    </Col>
                </Row>
            </Container>
        );
    }
}


